import {connect} from "react-redux";

import * as AuthActions from "../../store/actions/authActions";
import Login from "../../components/Auth/Login";

const mapStateToProps = (state) => ({
    ...state.auth
});

const mapDispatchToProps = (dispatch) => ({
    onLogin: (username, password, browser) => {
        dispatch(AuthActions.loginUser(username, password, browser));
    },
    authClear: () => {
        dispatch(AuthActions.clearErrors());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);


// WEBPACK FOOTER //
// ./src/containers/Auth/LoginContainer.js